import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import FloatingCTA from './components/FloatingCTA'

// Pages
import Home from './pages/Home'
import TemperatureTransport from './pages/TemperatureTransport'
import ExpressDelivery from './pages/ExpressDelivery'
import Vehicles from './pages/Vehicles'
import About from './pages/About'
import Contact from './pages/Contact'
import NotFound from './pages/NotFound'
import Forbidden from './pages/Forbidden'

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-slate-50 text-slate-900 font-sans selection:bg-sky-500 selection:text-white">
      <ScrollToTop />
      <FloatingCTA />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/temperaturstyret-transport" element={<TemperatureTransport />} />
          <Route path="/ekspreslevering" element={<ExpressDelivery />} />
          <Route path="/vores-biler" element={<Vehicles />} />
          <Route path="/om-transport4u" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}
